import React from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import cn from 'classnames'

import { getBestPrice } from 'src/effects/Availability/selectors'
import { useMarket } from 'src/hooks/useMarket'

import type { IBoardPrice } from 'client/components/Rooms/RoomResponsive/OfferResponsive/OfferPrice/types'
import OfferPrice from 'client/components/Rooms/RoomResponsive/OfferResponsive/OfferPrice'
import styles from './styles.module.css'
import Button from 'src/comps/Atom/Buttons/Button'
import { calculateDiscount } from 'client/utils'

interface MainPriceProps {
  handleClick: () => void
  showFrom?: boolean
  showSubtitle?: boolean
}

const HotelDetailMainPrice: React.FC<MainPriceProps> = ({
  handleClick,
  showFrom,
  showSubtitle = true,
}) => {
  const intl = useIntl()
  const { currency } = useMarket()

  const {
    price,
    pricePerNight,
    priceBefore,
    priceWithFees,
    pricePerNightSubtotal,
    pricePerNightWithFees,
    subtotal,
    subtotalWithFees,
    subtotalNightlyWithFees,
  } = useSelector(getBestPrice)

  const board: IBoardPrice = {
    finalPrice: price,
    pricePerNight,
    initialPrice: priceBefore,
    totalWithFees: priceWithFees,
    pricePerNightSubtotal,
    pricePerNightWithFees,
    subtotal,
    subtotalWithFees,
    subtotalNightlyWithFees,
    currency,
    discount: calculateDiscount(price, priceBefore) ?? 0,
  }

  return (
    <div className={cn(styles.mainPrice)} data-testid="mainPrice">
      <OfferPrice
        board={board}
        showDiscount={false}
        showDiscountBadge={false}
        showSubtitle={showSubtitle}
        showFrom={showFrom}
      />

      <Button
        size="m"
        onClick={handleClick}
        backgroundColor="brand1"
        borderColor="brand1"
        data-testid="offer-cta"
      >
        {intl.formatMessage({ id: 'global.book-now' })}
      </Button>
    </div>
  )
}

export default HotelDetailMainPrice
